export default __webpack_public_path__ + "static/media/element_17.01eb1764.avif";